import { render } from "./IssueTypeComponent.vue?vue&type=template&id=64118588&scoped=true&ts=true"
import script from "./IssueTypeComponent.vue?vue&type=script&lang=ts"
export * from "./IssueTypeComponent.vue?vue&type=script&lang=ts"

import "./IssueTypeComponent.vue?vue&type=style&index=0&id=64118588&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-64118588"]])

export default __exports__